import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class TpAdminSearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpAdminSearchParams';

  constructor(userId) {
    super();
    this.UserId = userId;
    this.ThirdPartyAdminId = '';
    this.ThirdPartyAdminName = '';
    this.ThirdPartyAdminEmail = '';
    this.ThirdPartyIsActive = '';
    this.ThirdPartySource = '';
    this.ThirdPartyIsActive = '';
  }
  initialize() {}

  static fieldsInSearchBox = [
    {
      fieldName: 'ThirdPartyAdminId',
      label: 'Third-Party Admin Id',
      type: InputTypesEnum.Text,
      className: 'col-4',
    },
    {
      fieldName: 'ThirdPartyAdminName',
      label: 'Name',
      type: InputTypesEnum.Text,
      className: 'col-4',
    },
    {
      fieldName: 'ThirdPartyAdminEmail',
      label: 'Email',
      type: InputTypesEnum.Text,
      className: 'col-4',
    },
    {
      fieldName: 'ThirdPartyIsActive',
      label: 'Is Active',
      type: InputTypesEnum.EmptyYesNoSelect,
      className: 'col-4',
    },
    {
      fieldName: 'ThirdPartySource',
      label: 'Source',
      type: InputTypesEnum.ThirdPartySourceSelect,
      className: 'col-4',
    },
  ];
}
